import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { updateOperationWindowRuleNote } from '@api/operationWindowRules';

import { IId, INotes } from '@interfaces/common/common';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { OPERATION_WINDOW_RULES, OPERATION_WINDOW_RULES_EDIT_NOTES  } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateOperationWindowRulesUpdateNotesReturned {
	isLoadingUpdateNotes: boolean;
	updateNotes: UseMutateFunction<any, any, IId & INotes, any>;
}

const useMutateOperationWindowRulesUpdateNotes = (): IUseMutateOperationWindowRulesUpdateNotesReturned => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutateAsync,
		isLoading,
	} = useMutation<IId & INotes>({
		mutationKey: [OPERATION_WINDOW_RULES_EDIT_NOTES],
		mutationFn: updateOperationWindowRuleNote,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.updateOperationWindowRuleNotes,
				type: ESnackbarTypes.success,
			}));

			return queryClient.invalidateQueries([OPERATION_WINDOW_RULES]);
		},
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
	});

	return {
		isLoadingUpdateNotes: isLoading,
		updateNotes: mutateAsync,
	};
};

export default useMutateOperationWindowRulesUpdateNotes;
